import type { Option } from 'shared/types';

export const getActiveSortButtons = (list: Array<Option<number>>, min: number, max: number) =>
  list.filter(({ value }) => value >= min && value <= max);
